import React, { useState } from "react";
import { useForm } from "react-hook-form";
import TextField from "./TextField";
import Button from "./Button";
import LoadingIcon from "./LoadingIcon";
import { useAuth } from "./../util/auth";
import { useRouter, useNavigate, useLocation } from "../util/router";
import { handleEmail } from "./../util/email"

function AuthForm(props) {
  const auth = useAuth();
  const router = useRouter()
  const navigate = useNavigate()
  const location = useLocation()

  const [pending, setPending] = useState(false);
  // T-011: Get lead data from localStorage for prefilling
  const getLeadData = () => {
    try {
      const stored = localStorage.getItem('iat_lead_data');
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error('Error loading lead data:', error);
    }
    return null;
  };

  const leadData = getLeadData();
  const defaultValues = leadData ? { email: leadData.email } : {};

  const { handleSubmit, register, formState: { errors }, getValues } = useForm({ defaultValues });
  const [validateEmailMessage, setValidateEmailMessage] = useState("")

  const submitHandlersByType = {
    signin: async ({ email, pass }) => {
      const next = new URLSearchParams(location.search).get("next") || "/dashboard/dashboard"
      const user = await auth.signin(email, pass, router.query.referee)
      navigate(next)
    },
    signup: async ({ email, pass }) => {
      // extract next at the beginning
      const next = new URLSearchParams(location.search).get("next") || "/info/new"
      const res = await handleEmail("validateEmail", {
        "email": email
      })
      if (!res.success) {
        setValidateEmailMessage(res.message)
        setPending(false);
        return false
      }
      const user = await auth.signup(email, pass, router.query.referee)

      try {
        if (window.fbq) {
          window.fbq('track', 'CompleteRegistration', { content_name: 'New Account' });
        }
      } catch (error) {
        console.warn("Pixel tracking error:", error);
      }

      navigate(next)
    },
    forgotpass: ({ email }) => {
      return auth.sendPasswordResetEmail(email).then(() => {
        setPending(false);
        // Show success alert message
        props.onFormAlert({
          type: "success",
          message: "Password reset email sent",
        });
      });
    },
    changepass: ({ pass }) => {
      return auth.confirmPasswordReset(pass).then(() => {
        setPending(false);
        // Show success alert message
        props.onFormAlert({
          type: "success",
          message: "Your password has been changed",
        });
      });
    },
  };

  // Handle form submission
  const onSubmit = ({ email, pass }) => {
    // Show pending indicator
    setPending(true);

    // Call submit handler for auth type
    submitHandlersByType[props.type]({
      email,
      pass,
    }).catch((error) => {
      setPending(false);
      // Show error alert message
      props.onFormAlert({
        type: "error",
        message: error.message,
      });
    });
  };

  return (
    <form className="space-y-3" onSubmit={handleSubmit(onSubmit)}>
      {["signup", "signin", "forgotpass"].includes(props.type) && (
        <TextField
          type="email"
          id="email"
          placeholder="Email"
          error={errors.email}
          {...register("email", {
            required: "Please enter an email address",
          })}
        />
      )}
      {(props.type === "signup" && validateEmailMessage === "") && (
        <p className="text-sm md:text-sm text-center text-green-700">Please use a personal email, sometimes corporate emails can interfere with receiving emails from us.</p>
      )}
      {(validateEmailMessage !== "") && (
        <p className="text-sm md:text-sm text-center text-red-700">{validateEmailMessage}</p>
      )}

      {["signup", "signin", "changepass"].includes(props.type) && (
        <TextField
          type="password"
          id="pass"
          placeholder="Password"
          error={errors.pass}
          {...register("pass", {
            required: "Please enter a password",
          })}
        />
      )}

      {["signup", "changepass"].includes(props.type) && (
        <TextField
          type="password"
          id="confirmPass"
          placeholder="Confirm Password"
          error={errors.confirmPass}
          {...register("confirmPass", {
            required: "Please enter your password again",
            validate: (value) => {
              if (value === getValues("pass")) {
                return true;
              } else {
                return "This doesn't match your password";
              }
            },
          })}
        />
      )}

      <Button type="submit" size="md" disabled={pending} isBlock={true}>
        {pending && <LoadingIcon className="w-6" />}

        {!pending && <>{props.buttonAction}</>}
      </Button>
    </form>
  );
}

export default AuthForm;
